import { useState } from "react";

export interface FaqItem {
  id: number;
  question: string;
  answer: string;
}

interface FaqAccordionProps {
  items: FaqItem[];
  defaultOpenId?: number;
}

export default function FaqAccordion({ items, defaultOpenId }: FaqAccordionProps) {
  const [openId, setOpenId] = useState<number | null>(defaultOpenId ?? null);

  return (
    <div className="flex flex-col gap-3">
      {items.map((item) => {
        const isOpen = openId === item.id;
        return (
          <article
            key={item.id}
            className={`overflow-hidden rounded-lg border transition-colors duration-300 ${
              isOpen ? "border-primary-300 bg-background-50" : "border-background-200 bg-background-50"
            }`}
          >
            <button
              type="button"
              onClick={() => setOpenId(isOpen ? null : item.id)}
              aria-expanded={isOpen}
              className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
            >
              <h3 className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                {item.question}
              </h3>
              <span
                className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm transition-colors ${
                  isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-700"
                }`}
              >
                <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
              </span>
            </button>
            {isOpen ? (
              <div className="border-t border-background-200 px-4 pb-4 pt-3 md:px-5">
                <p className="text-sm leading-relaxed text-foreground-600">{item.answer}</p>
              </div>
            ) : null}
          </article>
        );
      })}
    </div>
  );
}